<div class="form-group">
  <!-- Upload Header -->
  <div class="upload-header">
    <label class="upload-label">{{ label }}</label>
    <span class="required-asterisk" *ngIf="required">*</span>
  </div>

  <div class="upload-row">
    <!-- File Upload Container -->
    <div class="file-upload-container">
      <div class="file-display">
        <span class="file-name">{{ fileName || "No file chosen" }}</span>
        <button type="button" class="choose-file-btn"  (click)="onChooseFile()" [disabled]="isUploading || disabled">
          Choose File
        </button>
      </div>

      <!-- Hidden File Input -->
      <div class="file-input-section">
        <input type="file" #fileInput [disabled]="disabled" (change)="onFileSelected($event)" [accept]="acceptedTypes"
          style="display: none" />
      </div>
    </div>

    <!-- Info Icon with Tooltip -->
    <div class="info-icon" tabindex="0" *ngIf="tooltipText">
      i
      <span class="tooltip-text">{{ tooltipText }}</span>
    </div>
  </div>

  <!-- File Row (when file is selected or existing) -->
  <div class="file-row" *ngIf="selectedFile || isExistingFile">
    <span class="file-name">{{ fileName }}</span>
    <span class="file-size" *ngIf="fileSize">{{ fileSize }}</span>

    <div class="file-actions">
      <!-- ✅ REMOVED: Upload button - now auto-uploads on selection -->
      
      <button type="button" class="action-btn show-btn" (click)="openPdfPopup()" [disabled]="isUploading">
        عرض
      </button>

      <button type="button" class="action-btn delete-btn" (click)="removeFile()" [disabled]="isUploading">
        🗑️ حذف
      </button>
    </div>
  </div>

  <!-- ✅ Progress Bar (shown during upload) -->
  <mat-progress-bar *ngIf="isUploading" mode="determinate" [value]="uploadProgress">
  </mat-progress-bar>

  <p *ngIf="isUploading">جاري الرفع: {{uploadProgress}}%</p>
  
  <!-- Error Message -->
  <div class="upload-section" *ngIf="showError">
    <span class="upload-link error-message">{{ errorMessage }}</span>
  </div>

  <!-- PDF Modal -->
  <div class="pdf-modal" *ngIf="showPopup">
    <div class="modal-overlay" (click)="closePdfPopup()"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">{{ fileName }}</h3>
        <button class="close-btn" (click)="closePdfPopup()">&times;</button>
      </div>
      <div class="pdf-viewer">
        <object *ngIf="pdfUrl" [data]="safePdfUrl" type="application/pdf" width="100%" height="100%">
          <embed [src]="safePdfUrl" type="application/pdf" width="100%" height="100%">
          <p>PDF viewer not supported. <a [href]="pdfUrl" target="_blank">Download PDF</a></p>
        </object>
      </div>
    </div>
  </div>
</div>